import styled from "styled-components";

import { PAGE_HEIGHT } from "constants/styles";

export const PageContainer = styled("main")(({ theme }) => ({
  padding: theme.spacing(4),
  backgroundColor: theme.palette.ui12,
  height: PAGE_HEIGHT,
  position: "relative",
  overflow: "auto",
}));
